import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NewInventoryAdjustment } from "./model/new-inventory-adjustment";
import { NewInventoryAdjustmentResult } from "./model/new-inventory-adjustment-result";

@Injectable()
export class InventoryAdjustmentService {
  constructor(private httpClient: HttpClient) { }

  public create(newInventoryAdjustement: NewInventoryAdjustment): Observable<NewInventoryAdjustmentResult> {
    return this.httpClient.post<NewInventoryAdjustmentResult>("/api/inventory/adjustment", newInventoryAdjustement);
  }
}